module.exports = __webpack_public_path__ + "static/media/science_structure.5b764ccd.svg";